import { render } from "./AddRebate.vue?vue&type=template&id=870486a8"
import script from "./AddRebate.vue?vue&type=script&lang=js"
export * from "./AddRebate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__